import { c as _c } from "react/compiler-runtime";
import { useContext } from "react";
import { DEFAULT_FILTERS } from "../features/filters/constants";
import type { Filters } from "../features/filters/types";
import { StoreContext } from "./StoreProvider";
export const useStoreSlices = () => {
  const $ = _c(2);
  const store = useContext(StoreContext);
  if (!store) {
    throw new Error("useAppStore must be used within StoreProvider");
  }
  let t0;
  if ($[0] !== store) {
    t0 = {
      setMobileFiltersOpen: isOpen => store.setState(state => ({
        ...state,
        mobileFiltersOpen: isOpen
      })),
      setMobileMapVisible: isVisible => store.setState(state_0 => ({
        ...state_0,
        mobileMapVisible: isVisible
      })),
      setFilters: filters => store.setState(state_1 => ({
        ...state_1,
        filters
      })),
      setFilter: (filter, value) => store.setState(state_2 => ({
        ...state_2,
        filters: {
          ...state_2.filters,
          [filter]: value
        }
      })),
      updateFilters: filters_0 => store.setState(state_3 => ({
        ...state_3,
        filters: {
          ...state_3.filters,
          ...filters_0
        }
      })),
      resetFilters: () => store.setState(_temp)
    };
    $[0] = store;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
function _temp(state_4) {
  return {
    ...state_4,
    filters: DEFAULT_FILTERS
  };
}